"use client";
import * as React from "react";
const SvgExploreOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 14.4A6.4 6.4 0 0 1 1.6 8 6.4 6.4 0 1 1 8 14.4m-4.4-2 6-2.8 2.8-6-6 2.8zM8 7.12c.49 0 .88.4.88.88s-.4.88-.88.88A.9.9 0 0 1 7.12 8c0-.49.4-.88.88-.88" }));
export {
  SvgExploreOutlined as default
};
